import {AddCircleOutline} from "@mui/icons-material";
import {lazy} from "react";
import type {Page, PageGroup} from "router/types";
import {ROLE_SUPER_ADMIN} from "utils/roles";

const TopUpsPage = lazy(() => import("pages/top-ups/TopUpsPage"));

const topUpRoutes: Array<Page | PageGroup> = [
  {
    segment: "top-ups",
    title: "Top Ups",
    Icon: AddCircleOutline,
    Component: TopUpsPage,
    roles: [ROLE_SUPER_ADMIN],
  },
];

export default topUpRoutes;
